module.exports = __webpack_public_path__ + "static/media/Ghibli Header Logo.f8cbe712.png";